import React,{ Fragment, useEffect, useState } from "react";
import useClickOutside from "../useClickOutside";

const ImgViews = ({ close, src }) => {
  let domNode = useClickOutside(() => {
    close(false);
  });
  return (
    <Fragment>
      <div className="mfp-bg mfp-ready" onClick={() => close(false)}></div>
      <div
        className="mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-ready"
        tabIndex={-1}
        style={{ overflow: "hidden auto" }}
      >
        <div
          className={` popup-container mfp-container mfp-s-ready mfp-iframe-holder mfp-img-container`}
        >
          <div className="mfp-content" ref={domNode}>
            <div className="mfp-iframe-scaler">
              <img className="mfp-img" src={src} />
            </div>
          </div>
          <div className="mfp-preloader">Loading...</div>
        </div>
      </div>
    </Fragment>
  );
};

const ImageView = () => {
  const [img, setImg] = useState(false);
  const [imgValue, setImgValue] = useState(null);

  useEffect(() => {
    const attachImageViewer = () => {
      const anchors = document.querySelectorAll("a");
      anchors.forEach((anchor) => {
        if (anchor.href.includes("/images")) {
          if (anchor.getAttribute("download") === null) {
            anchor.addEventListener("click", (e) => {
              e.preventDefault();
              setImgValue(anchor.href);
              setImg(true);
            });
          }
        }
      });
    };

    if ("requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(attachImageViewer, {
        timeout: 4000,
      });
      return () => window.cancelIdleCallback(idleId);
    }

    const timerId = window.setTimeout(attachImageViewer, 3000);
    return () => window.clearTimeout(timerId);
  }, []);
  return (
    <Fragment>
      {img && <ImgViews close={() => setImg(false)} src={imgValue} />}
    </Fragment>
  );
};
export default ImageView;
